var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Redirecting to verification page")]),_c('div',[(!_vm.isComplete)?_c('Spinner',{attrs:{"size":"huge"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }